import SubmissionsResponsive from './SubmissionsResponsive';

// No Redux wiring needed yet — props come from the router.
// Wire up state here when real submission data is available.
export default SubmissionsResponsive;
